import Widget from "csi/table/Widget";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import MilestoneReportMixin from "./MilestoneReportMixin";

const SiteMilestoneReportTable = declare([Widget, MilestoneReportMixin], {
	/** @property {boolean} detectTypes - to check if the node is eligible to add based on Action ControllerClassParams */
	detectTypes: false,

	/**
	 * @override
	 * Add the query according to the report needed.
	 */
	_resolveView() {
		var q = new Query();
		if (this.detectTypes) {
			this._addTypeClause(q);
		}
		this.relRoot.addQuery(q);
		this.inherited(arguments);
	},
});

export = SiteMilestoneReportTable;